import { ShiftClickDirective } from './sharedDirectives/shift-click.directive';
import { SignalRService } from './sharedServices/signal-r.service';
/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SearchUIComponent } from './searchFittingsComponents/search-ui/search-ui.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AddFittingComponent } from './fittingManagementComponents/add-fitting-size/add-fitting.component';
import { FittingApprovalPageComponent } from './fittingManagementComponents/fitting-approval-page/fitting-approval-page.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HeaderComponentComponent } from './masterComponents/header-component/header-component.component';
import { NavComponentComponent } from './masterComponents/nav-component/nav-component.component';
import { DialogBoxComponent } from './shared/dialog-box/dialog-box.component';
import { SearchFittingComponent } from './searchFittingsComponents/search-fitting/search-fitting.component';
import { UpdateFittingSizeComponent } from './fittingManagementComponents/update-fitting-size/update-fitting-size.component';
import { DeleteFittingSizeComponent } from './fittingManagementComponents/delete-fitting-size/delete-fitting-size.component';
import { CopyBlobFilesComponent } from './fittingManagementComponents/copy-blob-files/copy-blob-files.component';
import { AngularDraggableModule } from 'angular2-draggable';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { GenericTableComponent } from './shared/generic-table/generic-table.component';
import { GenericTableData } from './sharedServices/generic-table-data.service';
import { AngularSplitModule } from 'angular-split';
import { FittingSizeManagementService } from './sharedServices/fitting-size-management.service';
import { CustomSnackBarComponent } from './shared/customSnackBar/customSnackBar.component';
import { FittingStateManagementComponent } from './fittingManagementComponents/fitting-state-management/fitting-state-management.component';
import { UserSettingsPageComponent } from './fittingManagementComponents/user-settings-page/user-settings-page.component';
import { DataTableMultipleSelectionComponent } from './shared/data-table-multiple-selection/data-table-multiple-selection.component';
import { PipingPlumbingComponent } from './fittingSizesTables/PipingPlumbingFittingSize/piping-plumbing.component';
import { SheetMetalComponent } from './fittingSizesTables/SheetMetalFittingSize/sheet-metal.component';
import { FittingStateApprovalComponent } from './fittingManagementComponents/fitting-state-approval/fitting-state-approval.component';
import { CableTraysComponent } from './fittingSizesTables/CableTrays/cable-trays.component';
import { AuthentificationService } from './sharedServices/authentification.service';
import { SigninCallbackComponent } from './masterComponents/signin-callback/signin-callback.component';
import { TokenInterceptorService } from './sharedServices/tokenInterceptor.service';
import { UserHandlerService } from './sharedServices/user-handler.service';
import { MainPageComponent } from './masterComponents/main-page/main-page.component';
import { EnumToArrayPipe } from './shared/pipes/enumToArray.pipe';
import { ElectricalComponent } from './fittingSizesTables/ElectricalFittingSize/electrical.component';
import { SignoutCallbackComponent } from './masterComponents/signout-callback/signout-callback.component';
import { LoaderService } from './sharedServices/loader.service';
import { ApiModule } from 'api/api.module';
import { environment } from 'src/environments/environment';
import { SearchContentComponent } from './DownloadUpload/searchContent/search-content.component';
import { DropdownComponent } from './DownloadUpload/dropdown/dropdown.component';
import { UploadContentComponent } from './DownloadUpload/uploadContent/upload-content.component';
import { FolderPickerDirective } from './DownloadUpload/dropdown/Directives/folder-picker.directive';
import { DownloadService } from './DownloadUpload/services/download.service';
import { DownloadContentComponent } from './DownloadUpload/downloadContent/download-content.component';
import { UploadService } from './DownloadUpload/services/upload.service';
import { MaterialModule } from './material.module';

// tslint:disable-next-line: max-line-length

@NgModule({
  declarations: [
    AppComponent,
    SearchUIComponent,
    CopyBlobFilesComponent,
    AddFittingComponent,
    PipingPlumbingComponent,
    FittingApprovalPageComponent,
    HeaderComponentComponent,
    DataTableMultipleSelectionComponent,
    NavComponentComponent,
    DialogBoxComponent,
    SearchFittingComponent,
    UpdateFittingSizeComponent,
    DeleteFittingSizeComponent,
    GenericTableComponent,
    FittingStateManagementComponent,
    PipingPlumbingComponent,
    ElectricalComponent,
    SheetMetalComponent,
    CustomSnackBarComponent,
    UserSettingsPageComponent,
    FittingStateApprovalComponent,
    CableTraysComponent,
    SigninCallbackComponent,
    SignoutCallbackComponent,
    MainPageComponent,
    EnumToArrayPipe,
    DownloadContentComponent,
    SearchContentComponent,
    DropdownComponent,
    UploadContentComponent,
    FolderPickerDirective,
    ShiftClickDirective,
  ],

  imports: [
    MaterialModule,
    BrowserModule,    
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    AngularDraggableModule,
    NgbModule,
    AngularSplitModule,
    HttpClientModule,
    ApiModule.forRoot({ rootUrl: environment.rootURL }),
  ],
  // entryComponents: [
  //   DialogBoxComponent,
  //   CustomSnackBarComponent
  // ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true,
    },

    GenericTableData,
    FittingSizeManagementService,
    AuthentificationService,
    UserHandlerService,
    LoaderService,
    DownloadService,
    UploadService,
    SignalRService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
